// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"7e2b5e29","121":"1a20fc0b","340":"37ab63ab","482":"2aea75eb","607":"83d19b93","616":"3caf1aae","822":"e6772a2d","891":"419ea1ed"}[chunkId] + ".chunk.js";
};